// extracted by mini-css-extract-plugin
module.exports = {"btn":"reportedTweetList_btn__plHZB","delete":"reportedTweetList_delete__26U6m","view":"reportedTweetList_view__1nZjb"};